import * as moment from 'moment';

export function parseDate(d: any): moment.Moment {
    return moment.utc(d);
}

export function diff(d1: moment.Moment, d2: moment.Moment): string {
    const d = moment.duration(d2.diff(d1));
    let n = Math.round(d.asDays());
    if (n > 0) {
        return n + 'd';
    }
    n = Math.round(d.asHours());
    if (n > 0) {
        return n + 'h';
    }
    n = Math.round(d.asMinutes());
    if (n > 0) {
        return n + 'm';
    }
    n = Math.round(d.asSeconds());
    if (n > 0) {
        return n + 's';
    }
    return 'now';
}
